<template>
	<fragment>
		<common-header
			subname="권한 관리"
			name="권한 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:searchbox="searchbox"
		></common-header>

		<section ref="container" class="container">
			<nav class="side-nav">
				<ul class="side-nav-menu bar clearfix">
					<li v-for="auth in authList" :key="`auth-list-${hash(auth)}`">
						<a :class="selectedAuth === auth ? 'on' :''" @click="setAuth(auth)">{{auth.authName}}</a>
					</li>
				</ul>
			</nav>

			<div class="container-fiuld clearfix">
				<div class="attribution-panel clearfix">
					<div class="attribution">
						<div class="attribution-tit">
							관리자 권한
						</div>
						<div class="attribution-nav">
							<ul>
								<li v-for="auth in authInfo['관리자 권한']" :key="`auth-list-info-${hash(auth)}`">
									<a class="text-darkgray">
										<img src="images/attr-icon1.png" alt="" width="16">
										{{auth.name}}
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="attribution-con"  v-if="selectedAuth">
						<div class="attribution-list">
							<ul class="clearfix">
								<li>{{selectedAuth.authName}}</li>
							</ul>
						</div>
						<div class="attribution-radio">
							<ul class="clearfix">
								<li>
									<div class="input-group full-width"  v-for="authData in authInfo['관리자 권한']" :key="`auth-permission-info-${hash(authData)}-${hash(selectedAuth)}`">
										<span class="input-group-addon v-mid clearfix">
											<div class="checkbox blue">
												<input :id="`auth-permission-info-${hash(authData)}-admit-관리자권한`" @click="modifyAuthData('관리자 권한', authData, true)"
													type="radio" :name="`auth-permission-info-${hash(authData)}-관리자권한`" :checked="isAuthChecked('관리자 권한', authData)">
												<label :for="`auth-permission-info-${hash(authData)}-admit-관리자권한`" class="s-lineH round-left">접근허용</label>
											</div>
											<div class="checkbox blue">
												<input :id="`auth-permission-info-${hash(authData)}-deny-관리자권한`" type="radio" @click="modifyAuthData('관리자 권한', authData, false)"
													:name="`auth-permission-info-${hash(authData)}-관리자권한`" :checked="!isAuthChecked('관리자 권한', authData)">
												<label :for="`auth-permission-info-${hash(authData)}-deny-관리자권한`" class="s-lineH round-right">접근금지</label>
											</div>
										</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="attribution-panel clearfix">
					<div class="attribution">
						<div class="attribution-tit">
							CMS 권한
						</div>
						<div class="attribution-nav">
							<ul>
								<li v-for="auth in authInfo['CMS 권한']" :key="`auth-list-info-${hash(auth)}`">
									<a class="text-darkgray">
										<img src="images/attr-icon1.png" alt="" width="16">
										{{auth.name}}
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="attribution-con"  v-if="selectedAuth">
						<div class="attribution-list">
							<ul class="clearfix">
								<li>{{selectedAuth.authName}}</li>
							</ul>
						</div>
						<div class="attribution-radio">
							<ul class="clearfix">
								<li>
									<div class="input-group full-width"  v-for="authData in authInfo['CMS 권한']" :key="`auth-permission-info-${hash(authData)}-${hash(selectedAuth)}`">
										<span class="input-group-addon v-mid clearfix">
											<div class="checkbox blue">
												<input :id="`auth-permission-info-${hash(authData)}-admit-cms권한`" @click="modifyAuthData('CMS 권한', authData, true)"
													type="radio" :name="`auth-permission-info-${hash(authData)}-cms권한`" :checked="isAuthChecked('CMS 권한', authData)">
												<label :for="`auth-permission-info-${hash(authData)}-admit-cms권한`" class="s-lineH round-left">접근허용</label>
											</div>
											<div class="checkbox blue">
												<input :id="`auth-permission-info-${hash(authData)}-deny-cms권한`" type="radio" @click="modifyAuthData('CMS 권한', authData, false)"
													:name="`auth-permission-info-${hash(authData)}-cms권한`" :checked="!isAuthChecked('CMS 권한', authData)">
												<label :for="`auth-permission-info-${hash(authData)}-deny-cms권한`" class="s-lineH round-right">접근금지</label>
											</div>
										</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="attribution-panel clearfix">
					<div class="attribution">
						<div class="attribution-tit">
							강사 권한
						</div>
						<div class="attribution-nav">
							<ul>
								<li v-for="auth in authInfo['강사 권한']" :key="`auth-list-info-${hash(auth)}`">
									<a class="text-darkgray">
										<img src="images/attr-icon1.png" alt="" width="16">
										{{auth.name}}
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="attribution-con"  v-if="selectedAuth">
						<div class="attribution-list">
							<ul class="clearfix">
								<li>{{selectedAuth.authName}}</li>
							</ul>
						</div>
						<div class="attribution-radio">
							<ul class="clearfix">
								<li>
									<div class="input-group full-width"  v-for="authData in authInfo['강사 권한']" :key="`auth-permission-info-${hash(authData)}-${hash(selectedAuth)}`">
										<span class="input-group-addon v-mid clearfix">
											<div class="checkbox blue">
												<input :id="`auth-permission-info-${hash(authData)}-admit-강사권한`" @click="modifyAuthData('강사 권한', authData, true)"
													type="radio" :name="`auth-permission-info-${hash(authData)}-강사권한`" :checked="isAuthChecked('강사 권한', authData)">
												<label :for="`auth-permission-info-${hash(authData)}-admit-강사권한`" class="s-lineH round-left">접근허용</label>
											</div>
											<div class="checkbox blue">
												<input :id="`auth-permission-info-${hash(authData)}-deny-강사권한`" type="radio" @click="modifyAuthData('강사 권한', authData, false)"
													:name="`auth-permission-info-${hash(authData)}-강사권한`" :checked="!isAuthChecked('강사 권한', authData)">
												<label :for="`auth-permission-info-${hash(authData)}-deny-강사권한`" class="s-lineH round-right">접근금지</label>
											</div>
										</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="attribution-panel clearfix">
					<div class="attribution">
						<div class="attribution-tit">
							관리자 메뉴
						</div>
						<div class="attribution-nav">
							<ul>
								<li v-for="menu in Object.keys(authInfo['관리자 메뉴'])" :key="`auth-list-info-${menu}`">
									<a class="text-darkgray">
										<img src="images/attr-icon1.png" alt="" width="16">
										{{menu}} {{menu.childs}}
									</a>
									<template v-if="authInfo['관리자 메뉴'][menu].childs">
										<ul v-for="child in Object.keys(authInfo['관리자 메뉴'][menu].childs)" :key="`auth-button-${child}`">
											<li>
												<a class="text-darkgray">
													<img src="images/attr-icon2.png" alt="" width="16">
													{{child}}
												</a>
											</li>
										</ul>
									</template>
								</li>
							</ul>
						</div>
					</div>
					<div class="attribution-con"  v-if="selectedAuth">
						<div class="attribution-list">
							<ul class="clearfix">
								<li>{{selectedAuth.authName}}</li>
							</ul>
						</div>
						<div class="attribution-radio">
							<ul class="clearfix">
								<li>
									<template v-for="menu in Object.keys(authInfo['관리자 메뉴'])">
										<div class="input-group full-width" :key="`auth-permission-info-${menu}`">
											<span class="input-group-addon v-mid clearfix">
												<div class="checkbox blue">
													<input :id="`menu-radio-${menu}-true`" type="radio" :name="`menu-radio-${menu}`" :checked="isMenuEnable(menu)" @click="modifyMenuData(menu, null, true)">
													<label :for="`menu-radio-${menu}-true`" class="s-lineH round-right">접근허용</label>
												</div>
												<div class="checkbox blue">
													<input :id="`menu-radio-${menu}-false`"  type="radio" :name="`menu-radio-${menu}`" :checked="!isMenuEnable(menu)" @click="modifyMenuData(menu, null, false)">
													<label :for="`menu-radio-${menu}-false`" class="s-lineH round-right">접근금지</label>
												</div>
											</span>
										</div>
										<template v-if="authInfo['관리자 메뉴'][menu].childs">
											<div class="input-group full-width" v-for="subMenu in Object.keys(authInfo['관리자 메뉴'][menu].childs)"
												:key="`auth-permission-info-${menu}-sub-${subMenu}`">
												<span class="input-group-addon v-mid clearfix">
													<div class="checkbox blue">
														<input :id="`menu-radio-${menu}-child-${subMenu}-true`"
															type="radio" :name="`menu-radio-${menu}-submenu-${subMenu}`" :checked="isMenuEnable(menu, subMenu)" @click="modifyMenuData(menu, subMenu, true)">
														<label :for="`menu-radio-${menu}-child-${subMenu}-true`" class="s-lineH round-right">접근허용</label>
													</div>
													<div class="checkbox blue">
														<input :id="`menu-radio-${menu}-child-${subMenu}-false`"
															type="radio" :name="`menu-radio-${menu}-submenu-${subMenu}`" :checked="!isMenuEnable(menu, subMenu)" @click="modifyMenuData(menu, subMenu, false)">
														<label :for="`menu-radio-${menu}-child-${subMenu}-false`" class="s-lineH round-right">접근금지</label>
													</div>
												</span>
											</div>
										</template>
									</template>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'

import AUTH_DATA from '../statics/auth_data'
import Axios from 'axios'
import server from '../statics/server'

export default {
	name: "ViewPermissionManager",
	mixins: [fnAdjustHeight],

	mounted:function() {
		this.getAuthList();
	},
	components: {
		CommonHeader,
		CommonFooter,
	},

	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'권한 관리',link:"/permissions",selected:true},
				{name:'권한 편집',link:"/permissions/list",selected:false},
			],
			buttons: [], // 헤더버튼
			members: [], // 검색된 모든 회원 목록
			selectedMember: null, // 현재 선택된 회원
			mainmenuOpened: true,
			searchbox:false,
			authInfo: AUTH_DATA,
			authList: [],
			selectedAuth: null,
			selectedAuthInfo: {}
		}
	},
	methods: {
		getAuthList: async function() {
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.AUTH}`, {});
				this.authList = data.list;
			} catch(e) {e}
		},
		setAuth(auth) {
			this.selectedAuth = auth;
			this.selectedAuthInfo = auth.authJson ? JSON.parse(auth.authJson) : {};
			// eslint-disable-next-line
			console.log(this.selectedAuthInfo);
		},
		isAuthChecked(rootName, auth) {
			// 아예 존재하지 않으면 false
			if (!this.selectedAuthInfo[rootName]) return false;
			// url과 method가 존재하는지 확인
			const isAuth = this.selectedAuthInfo[rootName].find((e)=>e.url === auth.url && e.method === auth.method);
			if(!isAuth) return false;

			return isAuth.permission;
		},
		modifyAuthData: async function(rootName, auth, permission) {
			// 아예 존재하지 않으면 만들어줌
			if (!this.selectedAuthInfo[rootName]) this.selectedAuthInfo[rootName] = [];

			// url과 method가 존재하는지 확인
			const isAuth = this.selectedAuthInfo[rootName].find((e)=>e.url === auth.url && e.method === auth.method);
			if(!isAuth) this.selectedAuthInfo[rootName].push({ name: auth.name, url: auth.url, method: auth.method, permission });
			else isAuth['permission'] = permission;

			await this.putAuthData();
		},
		isMenuEnable(menuName, childMenuName) {
			// 관리자 메뉴가 존재하지 않으면
			if (!this.selectedAuthInfo['관리자 메뉴']) return false;
			// 관리자 메뉴 => 메뉴의 존재 여부 확인
			if (!this.selectedAuthInfo['관리자 메뉴'][menuName]) return false;

			// childMenuName 인자가 비어있으면 menuName의 enabled를 확인
			if(!childMenuName) {
				return this.selectedAuthInfo['관리자 메뉴'][menuName].enabled
			}

			// 관리자 메뉴 => 메뉴 => 자식메뉴 존재 여부
			if (!this.selectedAuthInfo['관리자 메뉴'][menuName][childMenuName]) return false;
			// url과 method가 존재하는지 확인

			return this.selectedAuthInfo['관리자 메뉴'][menuName][childMenuName].enabled;
		},
		modifyMenuData: async function(menuName, childMenuName, enabled) {
			// 관리자 메뉴가 존재하지 않으면
			if (!this.selectedAuthInfo['관리자 메뉴']) this.selectedAuthInfo['관리자 메뉴'] = { };
			// 관리자 메뉴 => 메뉴의 존재 여부 확인
			if (!this.selectedAuthInfo['관리자 메뉴'][menuName]) this.selectedAuthInfo['관리자 메뉴'][menuName] = { enabled: false }

			// childMenuName 인자가 비어있으면 menuName의 enabled을 변경
			if(!childMenuName) {
				this.selectedAuthInfo['관리자 메뉴'][menuName].enabled = enabled;
			} else {
				// 관리자 메뉴 => 메뉴 => 자식메뉴 존재 여부
				if (!this.selectedAuthInfo['관리자 메뉴'][menuName][childMenuName]) this.selectedAuthInfo['관리자 메뉴'][menuName][childMenuName] = { enabled: false }
				this.selectedAuthInfo['관리자 메뉴'][menuName][childMenuName].enabled = enabled;
			}
			await this.putAuthData();
		},
		putAuthData: async function() {
			try {
				await Axios.patch(`${server.addr()}${server.api.AUTH}/${this.selectedAuth.authId}`, {
					authJson: JSON.stringify(this.selectedAuthInfo)
				});
				this.selectedAuth.authJson = JSON.stringify(this.selectedAuthInfo);
			} catch(e) {e}
		}
	}
}
</script>